import { useViewport } from '@xyflow/react'
import type { HelperLine } from '../hooks/useHelperLines'

interface HelperLinesProps {
  horizontal?: number
  vertical?: number
  lines?: HelperLine[]
}

/**
 * Componente que renderiza las líneas guía de alineamiento
 *
 * Muestra líneas horizontales y verticales que ayudan a alinear nodos
 * mientras se arrastran. Las líneas tienen en cuenta el viewport transform
 * (zoom y pan) para renderizarse correctamente.
 */
export function HelperLines({ horizontal, vertical, lines = [] }: HelperLinesProps) {
  const { x: viewportX, y: viewportY, zoom } = useViewport()

  // Si se usan las props directas (compatibilidad con versión simple)
  const allLines: HelperLine[] = [...lines]
  if (horizontal !== undefined) {
    allLines.push({ position: horizontal, orientation: 'horizontal' })
  }
  if (vertical !== undefined) {
    allLines.push({ position: vertical, orientation: 'vertical' })
  }

  if (allLines.length === 0) return null

  return (
    <div className="helper-lines-container">
      {allLines.map((line, index) => {
        if (line.orientation === 'horizontal') {
          return (
            <div
              key={`h-${index}`}
              className="helper-line helper-line-horizontal"
              style={{
                position: 'absolute',
                left: 0,
                right: 0,
                top: `${line.position * zoom + viewportY}px`,
                height: '1px',
                background: '#3b82f6',
                pointerEvents: 'none',
                zIndex: 100,
                boxShadow: '0 0 4px rgba(59, 130, 246, 0.5)'
              }}
            />
          )
        }

        // Vertical line
        return (
          <div
            key={`v-${index}`}
            className="helper-line helper-line-vertical"
            style={{
              position: 'absolute',
              top: 0,
              bottom: 0,
              left: `${line.position * zoom + viewportX}px`,
              width: '1px',
              background: '#3b82f6',
              pointerEvents: 'none',
              zIndex: 100,
              boxShadow: '0 0 4px rgba(59, 130, 246, 0.5)'
            }}
          />
        )
      })}
    </div>
  )
}
